import React from 'react';
import Icon from '../../../components/AppIcon';

const SiteHealthPanel = ({ sites }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Site Health Monitor</h3>
        <Icon name="Activity" size={20} className="text-primary" />
      </div>
      <div className="space-y-4">
        {sites?.map((site) => (
          <div key={site?.id} className="pb-4 border-b border-border last:border-0 last:pb-0">
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1">
                <h4 className="text-sm font-medium text-foreground mb-1">{site?.name}</h4>
                <p className="text-xs text-muted-foreground">{site?.url}</p>
              </div>
              <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                site?.status === 'online' ? 'bg-success/10 text-success' :
                site?.status === 'warning'? 'bg-warning/10 text-warning' : 'bg-error/10 text-error'
              }`}>
                <span className={`w-2 h-2 rounded-full ${
                  site?.status === 'online' ? 'bg-success' :
                  site?.status === 'warning'? 'bg-warning' : 'bg-error'
                }`} />
                {site?.status}
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-3 mt-3">
              <div className="flex items-center gap-2">
                <Icon name="Zap" size={14} className="text-muted-foreground" />
                <div>
                  <p className="text-xs text-muted-foreground">Uptime</p>
                  <p className="text-sm font-medium text-foreground">{site?.uptime}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Clock" size={14} className="text-muted-foreground" />
                <div>
                  <p className="text-xs text-muted-foreground">Response</p>
                  <p className="text-sm font-medium text-foreground">{site?.responseTime}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SiteHealthPanel;